export const RISK_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'RESOLVED',
};

export const RISK_MITIGATION_STRATEGY_STATUS = {
  WITH_STRATEGY: 'WITH_STRATEGY',
  WITHOUT_STRATEGY: 'WITHOUT_STRATEGY',
};

export const RISK_MITIGATION_STRATEGY_OPTIONS = {
  [RISK_MITIGATION_STRATEGY_STATUS.WITH_STRATEGY]: 'Yes',
  [RISK_MITIGATION_STRATEGY_STATUS.WITHOUT_STRATEGY]: 'No',
};

export const getRiskMitigationStrategyStatus = (mitigationStrategy?: Nullable<string>) =>
  mitigationStrategy ? RISK_MITIGATION_STRATEGY_STATUS.WITH_STRATEGY : RISK_MITIGATION_STRATEGY_STATUS.WITHOUT_STRATEGY;

export const RISK_STATUS_OPTIONS = {
  [RISK_STATUS.ACTIVE]: 'Active',
  [RISK_STATUS.INACTIVE]: 'Inactive',
};

const PROJECT_PROBABILITY = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
};
export const PROJECT_PROBABILITY_OPTIONS = {
  [PROJECT_PROBABILITY.HIGH]: 'High',
  [PROJECT_PROBABILITY.MEDIUM]: 'Medium',
  [PROJECT_PROBABILITY.LOW]: 'Low',
};

export const RISK_TYPE = {
  PROJECT_MANAGEMENT: 'PROJECT_MANAGEMENT',
  ENGINEERING: 'ENGINEERING',
  COMMERCIAL: 'COMMERCIAL',
  STAFFING: 'STAFFING',
};

export const RISK_TYPE_OPTIONS = {
  [RISK_TYPE.PROJECT_MANAGEMENT]: 'Project management',
  [RISK_TYPE.ENGINEERING]: 'Engineering',
  [RISK_TYPE.COMMERCIAL]: 'Commercial',
  [RISK_TYPE.STAFFING]: 'Staffing',
};
